// @flow

import FreezeBarColumns from './FreezeBarColumns';
import FreezeBarRows from './FreezeBarRows';

type Options = {
  onColFreezed?: () => mixed,
  onRowFreezed?: () => mixed,
  frozenColumns?: number,
  frozenRows?: number,
  horizontal?: boolean,
};

const FreezeBar = (options: Options): FreezeBarColumns | FreezeBarRows => {
  const { frozenColumns = 0, frozenRows = 0, horizontal } = options;

  if (horizontal) {
    return new FreezeBarRows({
      onRowFreezed: options.onRowFreezed,
      frozenRows,
    });
  }

  return new FreezeBarColumns({
    onColFreezed: options.onColFreezed,
    frozenColumns,
  });
};

export { FreezeBar };
